module.exports = __webpack_public_path__ + "static/media/pokemon_miss.d8b3790e.svg";